export default __webpack_public_path__ + "static/media/dashboard.bab35750.svg";